import { Controller } from "@hotwired/stimulus";

export default class VideoPlayerController extends Controller {
}
